import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import LoadingSpinner from './Components/Loader/LoadingSpinner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<LoadingSpinner />}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Suspense>
);